<template>
  <section class="row membersPortfolio justify-content-md-center">

    <div class="col col-lg-4 col-md-6 col-sm-6">
      <div class="maininfo">Bear</div>
      <div class="card" v-bind:class="{ flipped: isActive1 }" @click="setFlipped(1)">
        <div class="front">
          <img src="../assets/members/front/logo skear_2016.png" alt="member1_front" id="member1_front" class="img_front">
        </div>
        <div class="back">
          <img src="../assets/members/back/bear_skear.png" alt="member1_back" id="member1_back" class="img_back">
        </div>
      </div>
      <div class="subinfo">{{ $t('lead_developer') }}</div>
    </div>

    <div class="col col-lg-4 col-md-6 col-sm-6">
      <div class="maininfo">Philou</div>
      <div class="card" v-bind:class="{ flipped: isActive2 }" @click="setFlipped(2)">
        <div class="front">
          <img src="../assets/members/front/cat_asian.jpg" alt="member1_front" id="member1_front" class="img_front">
        </div>
        <div class="back">
          <img src="../assets/members/back/philou_skear.png" alt="member1_back" id="member1_back" class="img_back">
        </div>
      </div>
      <div class="subinfo">{{ $t('developer') }} / {{ $t('project_manager') }}</div>
    </div>

    <div class="col col-lg-4 col-md-6 col-sm-6">
      <div class="maininfo">Guigui</div>
      <div class="card" v-bind:class="{ flipped: isActive3 }" @click="setFlipped(3)">
        <div class="front">
          <img src="../assets/members/front/guigui_cat.png" alt="member1_front" id="member1_front" class="img_front">
        </div>
        <div class="back">
          <img src="../assets/members/back/guigui_skear.jpg" alt="member1_back" id="member1_back" class="img_back">
        </div>
      </div>
      <div class="subinfo">{{ $t('tester') }}</div>
    </div>

    <div class="col col-lg-4 col-md-6 col-sm-6">
      <div class="maininfo">Satan</div>
      <div class="card" v-bind:class="{ flipped: isActive4 }" @click="setFlipped(4)">
        <div class="front">
          <img src="../assets/members/front/satan_wolf.jpg" alt="member1_front" id="member1_front" class="img_front">
        </div>
        <div class="back">
          <img src="../assets/members/back/satan_skear.png" alt="member1_back" id="member1_back" class="img_back">
        </div>
      </div>
      <div class="subinfo">{{ $t('administration') }}</div>
    </div>

    <div class="col col-lg-4 col-md-6 col-sm-6">
      <div class="maininfo">Poney</div>
      <div class="card" v-bind:class="{ flipped: isActive5 }" @click="setFlipped(5)">
        <div class="front">
          <img src="../assets/members/front/poney_pikachu.png" alt="member1_front" id="member1_front" class="img_front">
        </div>
        <div class="back">
          <img src="../assets/members/back/poney_skear.png" alt="member1_back" id="member1_back" class="img_back">
        </div>
      </div>
      <div class="subinfo">{{ $t('tester') }}</div>
    </div>

  </section>
</template>

<script>
export default {
  name: "MembersPortfolio",
  data() {
    return {
      isActive1: false,
      isActive2: false,
      isActive3: false,
      isActive4: false,
      isActive5: false
    };
  },
  props: {
    msg: String
  },
  methods: {
    setFlipped(numb){
      switch(numb) {
        case 1:
            this.isActive1 = !this.isActive1;
          break;
        case 2:
            this.isActive2 = !this.isActive2;
          break;
        case 3:
            this.isActive3 = !this.isActive3;
          break;
        case 4:
            this.isActive4 = !this.isActive4;
          break;
        case 5:
            this.isActive5 = !this.isActive5;
          break;
        default:
          console.log(`Sorry, we are out of ${numb}.`);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.col{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 300px;
}
.maininfo{
  text-align: center;
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;
}
.subinfo{
  text-align: center;
  margin-top: 10px;
}
.card {
  min-width: 150px;
  min-height: 150px;
  transform-style: preserve-3d;
  transition: transform 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border-radius: 50%;
  box-shadow: 0 6px 16px rgba(0,0,0,0.15);
  cursor: pointer;
  img{
    width: 100%;
    height: 100%;
    border-radius: 50%;
    box-shadow: #ffffff 1px 0 10px;
  }
  div {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    border-radius: 50%;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font: 16px/1.5 "Helvetica Neue", Helvetica, Arial, sans-serif;
    color: #47525d;
  }
  .back {
    transform: rotateY(180deg);
  }
  &.flipped {
    transform: rotateY(180deg);
  }
}
</style>
